// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as DriverTerminationListTable from "./DriverTerminationListTable.bs.js";

function getView(tableData) {
  return React.createElement(DriverTerminationListTable.make, {
              tableData: tableData
            });
}

var DriverTerminationListViewMapper = {
  getView: getView
};

export {
  DriverTerminationListViewMapper ,
  
}
/* react Not a pure module */
